/**
 * Fourieraudio theme custom JS main file
 */
jQuery(document).ready(function () {
  //Burger Menu
  $(".burger_menu").click(function () {
    $(".mobile_menu").slideToggle();
    $(".fullscreen_black_div").fadeToggle();
    $(this).toggleClass("menu_active");
    $(".burger-icon").toggle();
    $(".close-icon").toggle();
    $(".wrapper span.label").text(function (i, text) {
      return text === "menu" ? "Close" : "menu";
    });
  });

  $('.copy').on('click', function() {
    // Get the current page URL
    var pageUrl = window.location.href;

    // Create a temporary input element
    var tempInput = $('<input>');
    $('body').append(tempInput);

    // Set the value of the input element to the page URL
    tempInput.val(pageUrl);

    // Select the text in the input element
    tempInput.select();
    tempInput[0].setSelectionRange(0, 99999); /* For mobile devices */

    // Copy the selected text to the clipboard
    document.execCommand('copy');

    // Remove the temporary input element
    tempInput.remove();

    // Show an alert to indicate that the URL has been copied
    alert('Page URL copied to clipboard: ' + pageUrl);
});

  var imageContainer = $(".image_surround");
  var fullscreenPopup = $("#fullscreen-popup");
  var fullscreenImage = $("#fullscreen-image");

  function openFullscreenPopup(imageSrc) {
      fullscreenImage.attr("src", imageSrc);
      fullscreenPopup.css("display", "block");
  }

  function closeFullscreenPopup() {
      fullscreenPopup.css("display", "none");
  }

  // Open the fullscreen popup when the image is clicked
  imageContainer.on("click", ".dynamicImg", function () {
      var imageSrc = $(this).attr("src");
      openFullscreenPopup(imageSrc);
  });

  // Close the fullscreen popup when the close button is clicked
  fullscreenPopup.on("click", ".close-popup", function () {
      closeFullscreenPopup();
  });

  //post arrows
  // Custom SVG for "Next" link
  var nextSvg =
    'Next <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M3.83301 8.00004H13.1663M13.1663 8.00004L8.49967 3.33337M13.1663 8.00004L8.49967 12.6667" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  // Custom SVG for "Previous" link
  var prevSvg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M13.1663 8.00004H3.83301M3.83301 8.00004L8.49967 12.6667M3.83301 8.00004L8.49967 3.33337" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg> Previous';

  // Replace "Next" link content with custom SVG
  $(".next.page-numbers").html(nextSvg);
  // Replace "Previous" link content with custom SVG
  $(".prev.page-numbers").html(prevSvg);

  /**
   * Post Single TOC
   */
  // Initialize an empty table of contents
  var toc = $("<ul>");

  // Find all headings inside .main_content
  $(".main_content :header").each(function (index) {
    var heading = $(this);
    var headingText = heading.text();
    var headingId = "heading_" + index;

    // Assign an id to the heading if it doesn't have one
    if (!heading.attr("id")) {
      heading.attr("id", headingId);
    }

    // Create a list item for the table of contents
    var listItem = $(
      '<li><a href="#' + headingId + '">' + headingText + "</a></li>"
    );

    // Add the list item to the table of contents
    toc.append(listItem);
  });

  // Append the table of contents to .main_content
  $(".toc").append(toc);

  //video play
  if ($(".frame-holder").length) {
    $(".frame-holder span").click(function () {
      var video = $(this).parent().next().data("video");
      $(this).hide();
      $(this).parent().find("img").hide();
      $(this).parent().next().find("iframe").attr("src", video);
      $(this).parent().next().show();
      //console.log(video);
    });
  }

  //cf7
  $("#submit_form").click(function () {
    $(".wpcf7-submit").trigger("click");
  });

  // Initialize the Slick slider
  if ($(".slider").length) {
    $(".slider").slick({
      slidesToShow: 1, // Number of slides to show on mobile
      slidesToScroll: 1, // Number of slides to scroll
      mobileFirst: true, // Start with mobile-first approach
      responsive: [
        {
          breakpoint: 999, // Breakpoint for desktop
          settings: {
            slidesToShow: 3, // Number of slides to show on desktop
            slidesToScroll: 1,
          },
        },
      ],
      autoplay: true, // Enable auto-scrolling
      autoplaySpeed: 6000, // Set the auto-scroll speed in milliseconds (e.g., 6000ms for 6 seconds per slide)
      arrows: false, // Hide the arrows
      infinite: false, // Disable infinite looping
      dots: false, // Hide the dots
    });
  }
  if ($(".team_slider").length) {
    var slider = $(".team_slider");
  
    // Initialize the Slick slider
    slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 999, // Breakpoint for desktop
          settings: {
            slidesToShow: 3, // Number of slides to show on desktop
            slidesToScroll: 1,
          },
        },
      ],
      arrows: false,
      infinite: false, // Disable infinite looping
    });
  
    // Custom click event handlers for the left and right arrows
    $(".arrows .left").on("click", function () {
      slider.slick("slickPrev"); // Go to the previous slide
    });
  
    $(".arrows .right").on("click", function () {
      slider.slick("slickNext"); // Go to the next slide
    });
  
    $(document).on("click", ".expand", function () {
      $(this).closest(".wrapper").find(".content").toggle();
      $(this).find("#Vector").toggle();
    });
  
    // Prevent default scroll behavior when scrolling the slider
    var isScrolling = false;

    slider.on("wheel", function (event) {
      var atStart = slider.slick("slickCurrentSlide") === 0;
      var atEnd = slider.slick("slickCurrentSlide") === slider.slick("getSlick").slideCount - 3;
  
      if (!atStart && !atEnd) {
        event.preventDefault();
      }
  
      isScrolling = true;
  
      if (event.originalEvent.deltaY > 0 && !atEnd) {
        // Scroll down
        slider.slick("slickNext");
      } else if (event.originalEvent.deltaY < 0 && !atStart) {
        // Scroll up
        slider.slick("slickPrev");
      }
  
      // Set a timeout to reset the scrolling flag
      setTimeout(function () {
        isScrolling = false;
      }, 500);
    });
  
    // Prevent page scroll when the slider is being scrolled
    $(window).on("wheel", function (event) {
      if (isScrolling) {
        event.preventDefault();
      }
    });
  }
  
  if ($(".features-slider").length) {
    var slider = $(".features-slider");

    // Initialize the Slick slider
    slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      variableHeight: true, // Set variableHeight option to true
      arrows: false,
      infinite: false, // Disable infinite looping
    });

    // Custom click event handlers for the left and right arrows
    $(".arrows .left").on("click", function () {
      slider.slick("slickPrev"); // Go to the previous slide
    });

    $(".arrows .right").on("click", function () {
      slider.slick("slickNext"); // Go to the next slide
    });
    $(document).on("click", ".expand", function () {
      $(this).closest(".wrapper").find(".content").toggle();
      $(this).find("#Vector").toggle();
    });
  }
});

$(document).ready(function () {
  var steps = $("[data-step]"); // Select all elements with the data-step attribute
  var currentIndex = 0; // Current step index
  var cycleInterval = 8000; // 10 seconds in milliseconds (adjust as needed)
  var cycleCount = 0; // To track the number of cycles
  var maxCycles = steps.length; // Maximum number of cycles (same as the number of steps)

  // Function to animate the progress bar within a given container
  function animateProgressBar(container) {
    var innerProgress = container.find(".inner-progress");
    var progressWidth = 100;
    var initialWidth = 0;

    innerProgress.css("width", "0");
    innerProgress.animate({ width: progressWidth }, cycleInterval, function() {
        // Reset the progress bar after the animation completes
        //if (container.is('.image_surround')) {
          innerProgress.css("width", initialWidth);
        //}
    });
  }

  // Function to cycle through steps and update content
  function cycleSteps() {
    // Get the current step element
    var currentStep = $(steps[currentIndex]);

    $('.inner-progress').stop(true).css("width", '0px');
    $('.active').removeClass('active');
    currentStep.addClass('active');

    // Reset the width of .inner-progress in .image_surround and the current step
    $(".image_surround .inner-progress").css("width", "0");
    currentStep.find(".inner-progress").css("width", "0");

    // Get data from the current step
    var imageSrc = currentStep.data("image");
    var smallText = currentStep.find(".large").text();

    // Update the image_surround
    $(".image_surround img").attr("src", imageSrc);
    $(".image_surround .large").text(smallText);

    // Animate the progress bars within the current step and image_surround
    animateProgressBar(currentStep);
    animateProgressBar($(".image_surround .progress"));

    cycleCount++;

    currentIndex = (currentIndex + 1) % steps.length; // Move to the next step or cycle back to the first step

    // If we've completed all cycles, clear the interval
    if (cycleCount >= maxCycles) {
      clearInterval(cycleIntervalID);
    }
  }
// Add a click event handler for the .zoom element
$('.features .zoom').click(function() {
  // Find the closest .image_surround element to the clicked .zoom element
  var $imageSurround = $(this).closest('.features').find('.image_surround');

  // Find the <img> element inside .image_surround and trigger a click event on it
  $imageSurround.find('img').click();
});


  // Function to handle step click event
  function handleStepClick(event) {
    var clickedStep = $(this);
    currentIndex = steps.index(clickedStep);

    $('.inner-progress').stop(true).css("width", '0px');
    $('.active').removeClass('active');
    clickedStep.addClass('active');

    // Reset the width of .inner-progress in .image_surround and the clicked step
    $(".image_surround .inner-progress").css("width", "0");
    clickedStep.find(".inner-progress").css("width", "0");

    // Get data from the clicked step
    var imageSrc = clickedStep.data("image");
    var smallText = clickedStep.find(".large").text();

    // Update the image_surround
    $(".image_surround img").attr("src", imageSrc);
    $(".image_surround .large").text(smallText);

    // Animate the progress bars within the clicked step and image_surround
    animateProgressBar(clickedStep);
    animateProgressBar($(".image_surround .progress"));
  }

  // Add a click event handler to each step
  steps.on("click", handleStepClick);


  // Initialize the Intersection Observer
  var options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5, // Trigger when 50% of the .features section is in view
  };

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        // Start the cycle when the .features section is in view
        cycleSteps();
        cycleIntervalID = setInterval(cycleSteps, cycleInterval);
        // Disconnect the observer to run the code only once
        observer.disconnect();
      }
    });
  }, options);

  if ($(".features").length) {

    // Observe the .features section
    var featuresSection = document.querySelector('.features');
    observer.observe(featuresSection);

  }

});

// Function to check if an element is in the viewport
function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// Function to observe the headings and update the links
function observeHeadingsAndLinks() {
  var links = document.querySelectorAll("ul li a"); // Select all links in the list
  var headings = document.querySelectorAll("h2, h3"); // Select all headings (adjust as needed)

  // Create an Intersection Observer
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      // For each heading in the viewport, update the corresponding link
      var id = entry.target.id;
      var link = document.querySelector('a[href="#' + id + '"]');
      
      if (entry.isIntersecting) {
        link.style.fontWeight = 'bold';
      } else {
        link.style.fontWeight = 'normal';
      }
    });
  });
  if ($(".single-post").length) {
    // Observe each heading
    headings.forEach(function (heading) {
      observer.observe(heading);
    });
  }
}

// Wait for the DOM to be ready
document.addEventListener("DOMContentLoaded", function () {
  observeHeadingsAndLinks();
});



//Access
// document.addEventListener('keydown', function(event) {
//   // Check if the pressed key is the Tab key
//   if (event.key === 'Tab') {
//       // Get all focusable elements on the page (links, buttons, inputs, etc.)
//       var focusableElements = document.querySelectorAll('a, button, input, select, textarea');

//       // Convert NodeList to an array for easier manipulation
//       var focusableElementsArray = Array.from(focusableElements);

//       // Find the index of the currently focused element
//       var currentIndex = focusableElementsArray.indexOf(document.activeElement);

//       // If the Tab key is pressed while focusing on the last element, focus on the first element
//       if (event.shiftKey) {
//           // If Shift key is also pressed, move focus to the previous element
//           if (currentIndex > 0) {
//               focusableElementsArray[currentIndex - 1].focus();
//           } else {
//               focusableElementsArray[focusableElementsArray.length - 1].focus();
//           }
//       } else {
//           // If Shift key is not pressed, move focus to the next element
//           if (currentIndex < focusableElementsArray.length - 1) {
//               focusableElementsArray[currentIndex + 1].focus();
//           } else {
//               focusableElementsArray[0].focus();
//           }
//       }

//       // Prevent the default Tab behavior
//       event.preventDefault();
//   }
// });


    jQuery(document).ready(function($) {
        const $track = $('.slider-track');
        const $items = $('.slider-item');
        const $prevButton = $('.slider-button-prev');
        const $nextButton = $('.slider-button-next');

        let currentIndex = 0;

        function updateSlider() {
            const itemWidth = $items.first().outerWidth();
            $track.css('transform', `translateX(-${currentIndex * itemWidth}px)`);
        }

        $prevButton.on('click', function() {
            if (currentIndex > 0) {
                currentIndex--;
                updateSlider();
            }
        });

        $nextButton.on('click', function() {
            if (currentIndex < $items.length - 1) {
                currentIndex++;
                updateSlider();
            }
        });

        $(window).on('resize', updateSlider);
    });

